import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-nested-sidebar-fiber-catalog',
  templateUrl: './nested-sidebar-fiber-catalog.component.html',
  styleUrls: ['./nested-sidebar-fiber-catalog.component.scss']
})
export class NestedSidebarFiberCatalogComponent implements OnInit, OnDestroy {
  subs: Subscription[] = [];

  brochure: any;

  constructor(
    public _httpService: HttpService,) { }

  ngOnInit(): void {
    this.getdocURL();
  }

  getdocURL(): void {
    this.subs.push(this._httpService.getSingleDownload('D04-00-007P').subscribe((data) => {
      console.log(data);
      
      // console.log(data['result']['Brochure'][0]['url']);
      if (data.result.Brochure[0].url) {
        this.brochure = data.result.Brochure[0].url;
      }
    }));
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub) => {
      sub.unsubscribe();
    });
  }

}
